import { Email, Send } from '@mui/icons-material'
import { Box, Button, Card, CardContent, Container, InputAdornment, TextField, Typography } from '@mui/material'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { routes } from '../routes'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../hooks/useAuth'
import { LoadingButton } from '@mui/lab'
import Errors from '../../components/global/Errors'
import { ApiError } from '../../shared/types/apiError.type'

function ForgotPassword() {
  const navigation = useNavigate()
  const { t } = useTranslation()
  const { requestResetPassword, isLoading, isError, error } = useAuth()
  const [email, setEmail] = useState('')
  const err = error?.response?.data as ApiError


  const handleRequestReset = async (email: string) => {
    try {
      await requestResetPassword(email)
      navigation(routes.AUTH_ROUTES.EMAIL_SENT_PASSWORD, { state: { email } })

    } catch (error) {

    }
  }

  return (
    <form onSubmit={(e) => {
      e.preventDefault()
      handleRequestReset(email)
    }}>

      <Container maxWidth='xs' sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Card sx={{ width: '100%' }}>
          <CardContent sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'start', gap: 3 }}>
            <div>
              <Typography fontWeight={500} variant='h4' fontSize={'18px'}>{t('resetting:request:submit')}</Typography>
            </div>

            <Errors isError={isError} error={err}></Errors>

            <TextField onChange={e => setEmail(e.target.value)} value={email} required type='email' fullWidth label={t('info:email')} placeholder='john@gmail.com'></TextField>

            <Box display={'flex'} justifyContent={'space-between'} flexDirection={'column'} width={'100%'}>
              <LoadingButton loading={isLoading} type='submit' fullWidth startIcon={<Send></Send>} variant='contained'   >{t('button:send')}</LoadingButton>
              <Button variant='text' size='small' sx={{ mt: 2 }} onClick={() => navigation(routes.AUTH_ROUTES.LOGIN)}>{t('registration:back')}</Button>
            </Box>
          </CardContent>
        </Card>
      </Container>
    </form>

  )
}

export default ForgotPassword